import * as React from "react";
import { useEffect, useState } from "react";
import i18n from "i18n";
import Spinner from "components/common/Spinner";
import applyLanguage from "util/applyLanguage";
const LanguageProvider = ({ language, children = void 0 }) => {
  const [isReady, setIsReady] = useState(() => i18n.language === language);
  useEffect(() => {
    applyLanguage(language).catch(() => {
    }).finally(() => setIsReady(true));
  }, [language]);
  if (!isReady) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return children;
};
export default LanguageProvider;
